module.exports = __webpack_public_path__ + "img/loan-management.fe18748b.svg";